import { MEDIA, type MediaPath } from '~/generated/media'
import { sized } from '~/utils/media'

// Screensaver pool: photos plus the small again-bg; portfolio mockups and gifs excluded.
const images = (Object.keys(MEDIA) as MediaPath[]).filter(
	(p) =>
		MEDIA[p].type === 'image' &&
		!p.endsWith('.gif') &&
		(!p.startsWith('portfolio/') || p === 'portfolio/again-bg.jpg'),
)

const getRandomImage = (): string => sized(images[Math.floor(Math.random() * images.length)], 1920)

export { images, getRandomImage }
